import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import es from './locales/es.json';
import en from './locales/en.json';
import fr from './locales/fr.json';
import pt from './locales/pt.json';
import ar from './locales/ar.json';
import { findRouteKey } from './routes';

const LANGS = ['es', 'en', 'fr', 'pt', 'ar'];
// Public URLs own their language: unprefixed public pages are always es-ES (crawlers report "en").
const urlLanguageDetector = {
  name: 'urlLang',
  lookup(): string | undefined {
    if (typeof window === 'undefined') return undefined;
    const seg = window.location.pathname.split('/').filter(Boolean);
    if (seg[0] && LANGS.includes(seg[0])) return seg[0];
    if (seg.length === 0 || findRouteKey(seg[0])) return 'es';
    return undefined;
  },
};
const detector = new LanguageDetector();
detector.addDetector(urlLanguageDetector);

i18n
  .use(detector)
  .use(initReactI18next)
  .init({
    resources: {
      es: { translation: es },
      en: { translation: en },
      fr: { translation: fr },
      pt: { translation: pt },
      ar: { translation: ar },
    },
    fallbackLng: 'es',
    supportedLngs: ['es', 'en', 'fr', 'pt', 'ar'],
    interpolation: { escapeValue: false },
    detection: {
      order: ['urlLang', 'localStorage', 'navigator'],
      lookupFromPathIndex: 0,
      caches: ['localStorage'],
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
